<template>
    <div class="box">
        <img src="@/assets/header.png" />
        <div class="formTable">
            <div class="box_center">
                <div class="input_main">
                    <div class="input-content" style="margin-bottom:14px">
                        <input v-model="dataFrom.idCard" class="input" type="text" placeholder="请输入身份证号后四位" maxlength="4">
                    </div>
                    <div class="input-content">
                        <input v-model="dataFrom.takePhone" class="input" maxlength="11" type="number" placeholder="请输入收货手机号" oninput="if(value.length>11)value=value.slice(0,11)">
                    </div>
                    <div class="error">{{errorMsg}}</div>
                </div>
                <div class="btn fcc" @click="selectChange">立即查询</div>
            </div>
        </div>
        <div class="comeBack" @click="goBack">返回上一页</div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            errorMsg:'',
            dataFrom:{
                idCard:'',
                takePhone:''
            }
        }
    },
    methods:{
        goBack(){
           this.$router.go(-1)
        },
        selectChange(){
            if(!this.dataFrom.idCard){
                this.errorMsg="请输入身份证号后四位"
                setInterval(()=>{
                    this.errorMsg= ''
                    clearInterval()
                },5000)
                return
            }
            if(!this.dataFrom.takePhone){
                this.errorMsg="请输入联系号码"
                setInterval(()=>{
                    this.errorMsg= ''
                    clearInterval()
                },5000)
                return
            }
            this.$router.push({name:'orderSearchDetails',query:{idCard:this.dataFrom.idCard,takePhone:this.dataFrom.takePhone}})
        }
    }
}
</script>
<style lang="less" scoped>
    .box{
        width: 100%;
        height: 100%;
        img{
            width: 100%;
            display: inherit;
        }
        .formTable{
            background: url(../../assets/bottom.png) no-repeat;
            background-size: 100% 100%;
            height: 80vh;
            padding: 0 20px;
            box-sizing: border-box;
            margin-top: -0.015rem;
            .box_center{
                min-height:300px;
                padding:24px 18px;
                box-sizing: border-box;
                background: #fff;
                border-radius:12px;
            }
            .input_main{
                margin-bottom: 33px;
            }
            .input-content {
                width: 100%;
                height: 48px;
                background: #fff;
                border-radius: 8px;
                overflow: hidden;
                border: 1px solid #f0f0f0;
                .input{
                    height: 100%;
                    float: left;
                    width: 100%;
                    line-height: 0.4rem;
                    font-size: 0.3rem;
                    color: #333;
                    padding: 0 0.42rem;
                }
            }
            .btn{
                width: 250px;
                height: 44px;
                background: linear-gradient(180deg, #FFCD37, #FF9A2E);
                border-radius:30px;
                font-size: 20px;
                text-align: center;
                line-height:44px;
                color: #000000;
                margin: 0 auto;
            }
        }
        .comeBack {
            width: max-content;
            padding:5px;
            box-sizing: border-box;
            position: fixed;
            top:10px;
            left: 0;
            border-radius: 0 0.5rem 0.5rem 0;
            color: #fff;
            background: rgba(0, 0, 0, 0.3);
            font-size: 0.02rem;
        }
        .error {
            font-size: 12px;
            color: red;
            margin-top: 10px;
        }
    }
</style>